import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import FinancialListChild from "./FinancialListChild";

const FinancialList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <FinancialListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default FinancialList;
